import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { useAuth } from '../hooks/useAuth';
import { useAuthStore } from '../store/authStore';


const Unauthorized: React.FC = () => {
  const navigate = useNavigate();
  const { getUserLevel, getGroupName } = useAuth();

  const handleGoBack = () => {
    navigate(-1);
  };

  const { user } = useAuthStore();
  const slug = user?.panel;

  const handleGoHome = () => {
    if (slug) {
      navigate(`/${slug}/dashboard`);
    } else {
      navigate('/');
    }
  };

  const handleRelogin = () => {
    // Limpar completamente o localStorage e redirecionar para login
    try {
      localStorage.removeItem('auth-storage');
      localStorage.removeItem('_pv001');
      localStorage.removeItem('token');
      localStorage.removeItem('authToken');
      localStorage.removeItem('accessToken');
    } catch (_) {}
    if (slug) {
      window.location.href = `/${slug}/login`;
    } else {
      window.location.href = '/';
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <h2 className="mt-6 text-3xl font-extrabold text-gray-900">
            Acesso Negado
          </h2>
          <p className="mt-2 text-sm text-gray-600">
            Você não tem permissão para acessar este recurso
          </p>
        </div>
        
        <Card>
          <CardHeader>
            <CardTitle className="text-red-600">403 - Não Autorizado</CardTitle>
            <CardDescription>
              Seu nível de acesso atual: <span className="font-semibold">{getGroupName()}</span>
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="text-sm text-gray-600">
              <p>Você está logado como: <span className="font-semibold">{getUserLevel()}</span></p>
              <p className="mt-2">
                Este recurso requer um nível de acesso superior ao seu.
                Entre em contato com um administrador se você acredita que isso é um erro.
              </p>
            </div>
            
            <div className="flex space-x-3">
              <Button
                onClick={handleGoBack}
                variant="outline"
                className="flex-1"
              >
                Voltar
              </Button>
              <Button
                onClick={handleGoHome}
                className="flex-1"
              >
                Ir para Dashboard
              </Button>
            </div>

            <div className="pt-2 border-t border-gray-200">
              <p className="text-xs text-gray-500 mb-2 text-center">
                Se você acredita que isso é um erro, tente fazer login novamente:
              </p>
              <Button
                onClick={handleRelogin}
                variant="outline"
                className="w-full text-orange-600 border-orange-300 hover:bg-orange-50"
              >
                Limpar sessão e fazer login novamente
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default Unauthorized;
